export default __webpack_public_path__ + "99fd8e6510175672244c57e117962ef6.jpg";